import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  accounts_email: '',
  accounts_phone: '',
  active: true,
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  bank_account_bsb: '',
  bank_account_name: '',
  bank_account_number: '',
  billing_start_date: '',
  business_number: '',
  data: {},
  details_colour: '',
  email: '',
  font_colour: '',
  font_light_colour: '',
  geo_country_id: undefined,
  highlight_colour: '',
  id: null,
  image_mode: '',
  in_house: false,
  invoice_pdf_file: null,
  invoice_pdf_file_name: '',
  last_billed_at: '',
  order_api: '',
  notes_enabled: false,
  options: {
    closed_days: [],
    downsample_color_images: false,
    image_icc_profile: '',
    image_icc_profile_rgb: '',
    image_quality: '',
    job_ticket_layout: 'orders',
    optimize_files: false,
    order_api_endpoint: '',
    order_total_override: false,
    outline_pdf_fonts: false,
    pdf_compatibility: '',
    pricing_api: '',
    require_identity_code: false,
    slack_booking_updates_webhook_url: '',
    slack_project_comments_webhook_url: '',
    slack_task_updates_webhook_url: '',
    strip_image_profile: 'false',
  },
  phone: '',
  salesforce_id: '',
  short_name: '',
  title: '',
  webhooks: [],
  website: '',
  zuora_account_number: '',
}

export const requiredFields = [
  { key: 'address_line_1' },
  { key: 'address_postcode' },
  { key: 'address_region' },
  { key: 'address_state' },
  { key: 'business_number' },
  {
    key: 'email',
    validation: (value: string) => {
      const emails = value.split(',').map(email => email.trim()).filter(string => string)
      return emails.every(email => isValidEmail(email))
    },
    invalidMessage: 'Invalid Email format',
  },
  { key: 'geo_country_id' },
  { key: 'phone' },
  { key: 'title' },
  { key: 'website' },
]

export default state
